<template>
  <div class="container">
    <h3>修改手机号</h3>
    <div>为保证您的账户安全，请选择一种方式进行身份认证</div>
    <div class="link-btn">
      <router-link to="/modifyTel/tel-authentication">
        <el-button v-trace-click="'n.3387.6053.0'">手机验证</el-button>
      </router-link>
      <br />
      <router-link to="/modifyTel/email-authentication">
        <el-button v-trace-click="'n.3387.6054.0'">邮箱认证</el-button>
      </router-link>
    </div>
    <span class="tip">
      <!--1、您的手机号在提交修改后，系统会实时更新；
      <br />2、此处修改手机号后，请同步修改钉钉手机号，否则会导致旧手机号失效后钉钉账号作废重开，聊天记录与群组丢失。-->
    </span>
  </div>
</template>

<script>
export default {
  name: "add",
  data() {
    return {
      tableData: []
    };
  },
  methods: {}
};
</script>

<style lang="scss" scope>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  h3 {
    margin: 30px 0 15px;
  }
}

.link-btn {
  margin-top: 30px;
  margin-bottom: 220px;
  button {
    margin-bottom: 20px;
    width: 120px;
    color: #4272ab;
    border-color: #4272ab;
  }
}
.tip {
  height: 24px;
  line-height: 24px;
  color: rgba(153, 153, 153, 1);
  font-size: 16px;
  font-family: PingFangSC-Regular;
}
</style>
